<header>
    <h1>Chess Coordinate trainer</h1>
</header>

<style>
    header {
        padding: 30px 10px;
    }

    h1 {
        text-align: center;
        font-weight: 500;
        font-size: 35px;
    }
</style>
